import axios from 'axios';
import { getMenus as getAllMenus, getAllProducts } from '../vendor/Vendor';

export const getAllOrders = () => {
  return (dispatch) => {
    axios
      .get('/getAllOrders')
      .then((data) => {
        dispatch({ type: 'GET_ALL_ORDERS', payload: data });
      })
      .catch((err) => {
        console.log('error is ', err);
      });
  };
};

export const getAllTransactions = (pageNumber, count = 10, id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/user-transactions/${id}?page_number=${pageNumber}&per_page_limit=${count}`)
        .then((resp) => {
          dispatch({
            type: 'USERS_TRANSACTION_LIST',
            payload: resp.data
          });
          resolve(true);
        })
        .catch((err) => { });
    });
  };
};

export const getAllDeliveryBoys = (i = 1, per_page_limit = 10) => {
  return (dispatch) => {
    axios
      .get(`/admin/driver/listing?page_number=${i}&per_page_limit=${per_page_limit}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_DRIVERS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllUsers = (i = 1, per_page_limit = 10) => {
  return (dispatch) => {
    axios
      .get(`/admin/getUsers?page_number=${i}&per_page_limit=${per_page_limit}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_USERS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllSms = (i = 1, per_page_limit = 10) => {
  return (dispatch) => {
    axios
      .get(`/admin/sms/listing?page_number=${i}&per_page_limit=${per_page_limit}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_SMS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};




export const getDiscountDetail = (discountId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/discount/details/${encodeURI(discountId)}`)
        .then((data) => {
          dispatch({ type: 'DISCOUNT_DETAIL', payload: data.data });
          resolve(data.data);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data }
            });
          } catch {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { error: 'Unable to get discount' }
            });
          } finally {
            reject(true);
          }
        });
    });
  };
}

export const getDriverDetail = (discountId) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({ type: 'API_PROGRESS', payload: false });
      axios
        .get(`/admin/driver/details/${encodeURI(discountId)}`)
        .then((data) => {
          dispatch({ type: 'DRIVER_DETAIL', payload: data.data });
          resolve(data.data);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data }
            });
          } catch {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { error: 'Unable to get driver' }
            });
          } finally {
            reject(true);
          }
        });
    });
  };
}


export const getColumns = (tableName) => {
  return (dispatch) => {
    axios
      .get(`/admin/getColumns?tableName=${encodeURI(tableName)}`)
      .then((data) => {
        dispatch({ type: 'GET_COLUMN_NAMES', payload: data.data });
      })
      .catch((err) => {
        console.log('error is ', err);
      });
  };
}

export const saveOfferMessage = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/addOfferMessage', data)
        .then((data) => {
          resolve(true);
        })
        .catch((error) => {
          reject(true);
        });
    });
  };
};

export const addSuperCategory = (categoryData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/super-category/save', categoryData)
        .then((data) => {
          dispatch({ type: 'CREATE_SUPERCATEGORY', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Super-category successfully added' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'CREATE_SUPERCATEGORY_ERROR',
              payload: error.response.data
            });
          } catch {
            dispatch({
              type: 'CREATE_SUPERCATEGORY_ERROR',
              payload: 'please try again'
            });
          } finally {
            reject(true);
          }
        });
    });
  };
};
export const updateSuperCategory = (categoryData) => {
  if (!categoryData.isPicknDrop) {
    categoryData.isPicknDrop = false
  }
  if (categoryData.coverImages && categoryData.coverImages.length == 0) {
    delete categoryData.coverImages
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/super-category/update', categoryData)
        .then(async (data) => {
          await dispatch({ type: 'UPDATE_SUPERCATEGORY', payload: data.data });
          await dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Super-category successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'UPDATE_SUPERCATEGORY_ERROR',
              payload: error.response.data
            });
            reject(false);
          } catch {
            dispatch({
              type: 'UPDATE_SUPERCATEGORY_ERROR',
              payload: 'please try again'
            });
          }
        });
    });
  };
};
export const deleteSuperCategories = (superCategoryId) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      await axios
        .delete(`/admin/super-category/delete/${superCategoryId}`)
        .then(() => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Super Category deleted' }
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { error: 'Unable to delete Super Category' }
          });
          reject(false);
        });
    });
  };
};

export const addSubcategory = (subCategory) => {
  return (dispatch) => {
    axios
      .post('/admin/sub-category/save', subCategory)
      .then((data) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'SubCategory successfully added' }
        });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getCategory = (i = 1) => {
  return (dispatch) => {
    axios
      .get(`/admin/super-category/listing?page_number=${i}&per_page_limit=10`)
      .then((data) => {
        dispatch({ type: 'GET_SUPERCATEGORY', payload: data.data });
        dispatch(getTotalPage(1, 'admin/super-category/listing'));
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getSupercategoryDetails = (superCategoryId) => {
  return (dispatch) => {
    axios
      .get(`/admin/super-category/details/${superCategoryId}`)
      .then((data) => {
        dispatch({ type: 'GET_SUPER_CATEGORY_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'Loading..' });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllCategory = (superCategoryId, count = 10) => {
  return (dispatch) => {
    axios
      .get(
        `/admin/category/listing/${superCategoryId}?page_number=1&per_page_limit=${count}`
      )
      .then((data) => {
        dispatch({ type: 'GET_ALL_CATEGORY', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const addDriver = (discount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/driver/save', discount)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Driver successfully added' }
          });
          resolve(true);
        })
    });
  };
}
export const addSms = (discount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/sms/save', discount)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'SMS successfully added' }
          });
          resolve(true);
        })
    });
  };
}
export const updateDriver = (discount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/driver/update', discount)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Driver successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data }
            });
          } catch {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: 'please try again' }
            });
          } finally {
            reject(false);
          }
        });
    });
  };
}
export const addDiscount = (discount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/addDiscount', discount)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Discount successfully added' }
          });
          resolve(true);
        })
    });
  };
}
export const updateDiscount = (discount) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/discount/update', discount)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Discount successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: error.response.data }
            });
          } catch {
            dispatch({
              type: 'ERROR_MESSAGE',
              payload: { general: 'please try again' }
            });
          } finally {
            reject(false);
          }
        });
    });
  };
}
export const addCategory = (categoryData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/category/save', categoryData)
        .then((data) => {
          dispatch({ type: 'CREATE_CATEGORY', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Category successfully added' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'CREATE_CATEGORY_ERROR',
              payload: error.response.data
            });
          } catch {
            dispatch({
              type: 'CREATE_CATEGORY_ERROR',
              payload: 'please try again'
            });
          } finally {
            reject(false);
          }
        });
    });
  };
};
export const updateCategory = (categoryData) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      axios
        .put('/admin/category/update', categoryData)
        .then((data) => {
          dispatch({ type: 'UPDATE_CATEGORY', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Category successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'UPDATE_CATEGORY_ERROR',
              payload: error.response.data
            });
          } catch {
            dispatch({
              type: 'UPDATE_CATEGORY_ERROR',
              payload: 'please try again'
            });
          } finally {
            resolve(false);
          }
        });
    });
  };
};
export const deleteCategories = (categoryId) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      await axios
        .delete(`/admin/category/delete/${categoryId}`)
        .then(() => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Category deleted' }
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { error: 'Unable to delete Category' }
          });
          reject(false);
        });
    });
  };
};

export const getCategoryDetails = (categoryId) => {
  return (dispatch) => {
    axios
      .get(`/admin/category/details/${categoryId}`)
      .then((data) => {
        dispatch({ type: 'GET_CATEGORY_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getMenus = (vendorId) => {
  return (dispatch) => {
    axios
      .get(
        `/admin/vendor/${vendorId}/menu/listing?page_number=1&per_page_limit=10&`
      )
      .then((data) => {
        dispatch({ type: 'GET_MENUS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const getRestaurantType = () => {
  return (dispatch) => {
    axios
      .get(
        `/admin/restaurantType/listing?page_number=1&per_page_limit=1000`
      )
      .then((data) => {
        dispatch({ type: 'GET_RESTAURANT_TYPE', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const addRestaurantTypeAdmin = (RestaurantTypeData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/restaurantType/save', RestaurantTypeData)
        .then((data) => {
          dispatch({ type: 'CREATE_RESTAURANT_TYPE', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Restaurant Type successfully added' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'CREATE_RESTAURANT_TYPE_ERROR',
              payload: error.response.data
            });
          } catch {
            dispatch({
              type: 'CREATE_RESTAURANT_TYPE_ERROR',
              payload: 'please try again'
            });
          } finally {
            reject(true);
          }
        });
    });
  };
};
export const updateRestaurantType = (RestaurantTypeData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/restaurantType/update', RestaurantTypeData)
        .then(async (data) => {
          await dispatch({ type: 'UPDATE_RESTAURANT', payload: data.data });
          await dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Super-category successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'UPDATE_RESTAURANT_ERROR',
              payload: error.response.data
            });
            reject(false);
          } catch {
            dispatch({
              type: 'UPDATE_RESTAURANT_ERROR',
              payload: 'please try again'
            });
          }
        });
    });
  };
};
export const getRestaurantTypeDetails = (RestaurantTypeId) => {
  return (dispatch) => {
    axios
      .get(`/admin/restaurantType/details/${RestaurantTypeId}`)
      .then((data) => {
        dispatch({ type: 'GET_RESTAURANT_TYPE_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const addMenu = (categoryData) => {
  return (dispatch) => {
    axios
      .post('/vendor/menu/save', categoryData)
      .then((data) => {
        dispatch({ type: 'CREATE_MENU', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Menu successfully added' }
        });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'CREATE_MENU_ERROR', payload: error.response.data });
        } catch {
          dispatch({ type: 'CREATE_MENU_ERROR', payload: 'please try again' });
        }
      });
  };
};
export const updateMenu = (categoryData) => {
  return (dispatch) => {
    axios
      .put(`/vendor/menu/update`, categoryData)
      .then((data) => {
        dispatch({ type: 'UPDATE_MENU', payload: data.data });
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Menu successfully updated' }
        });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'UPDATE_MENU_ERROR', payload: error.response.data });
        } catch {
          dispatch({ type: 'UPDATE_MENU_ERROR', payload: 'please try again' });
        }
      });
  };
};
export const getMenuDetails = (menuId) => {
  return (dispatch) => {
    axios
      .get(`/vendor/menu/details/${menuId}`)
      .then((data) => {
        dispatch({ type: 'GET_MENU_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const deleteMenu = (menuId) => {
  return async (dispatch) => {
    if (true) {
      try {
        await axios.delete(`/vendor/menu/delete/${menuId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Menu deleted' }
        });
        dispatch(getAllMenus());
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Menu' }
        });
      }
    } else {
      try {
        await axios.delete(`/vendor/menu/delete/${menuId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Menu deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete Menu' }
        });
      }
    }
  };
};

export const deleteMenuByadmin = (vendorId, menuId) => {
  return async (dispatch) => {
    if (true) {
      try {
        await axios.delete(`/admin/vendor/${vendorId}/menu/delete/${menuId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Menu deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Menu' }
        });
      }
    } else {
      try {
        await axios.delete(`/admin/vendor/${vendorId}/menu/delete/${menuId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Menu deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete Menu' }
        });
      }
    }
  };
};
export const deleteRestaurantTypeByadmin = (RestaurantTypeId) => {
  return async (dispatch) => {
    if (true) {
      try {
        await axios.delete(`/admin/restaurantType/delete/${RestaurantTypeId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Restaurant Type deleted' }
        });
        dispatch(getRestaurantType());
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Restaurant Type' }
        });
      }
    } else {
      try {
        await axios.delete(`/admin/restaurantType/delete/${RestaurantTypeId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'Restaurant Type deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete Restaurant Type' }
        });
      }
    }
  };
};

export const getAllSubCategory = (categoryId) => {
  return (dispatch) => {
    axios
      .get(`/admin/sub-category/listing/${categoryId}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_SUBCATEGORY', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const addSubCategory = (categoryData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/sub-category/save', categoryData)
        .then((data) => {
          dispatch({ type: 'CREATE_SUB_CATEGORY', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'SubCategory successfully added' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'CREATE_SUB_CATEGORY_ERROR',
              payload: error.response.data
            });
          } catch {
            dispatch({
              type: 'CREATE_SUB_CATEGORY_ERROR',
              payload: 'please try again'
            });
          } finally {
            reject(false);
          }
        });
    });
  };
};
export const updateSubCategory = (categoryData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/sub-category/update', categoryData)
        .then((data) => {
          dispatch({ type: 'UPDATE_SUB_CATEGORY', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'subCategory successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'UPDATE_SUB_CATEGORY_ERROR',
              payload: error.response.data
            });
            reject(false);
          } catch {
            dispatch({
              type: 'UPDATE_SUB_CATEGORY_ERROR',
              payload: 'please try again'
            });
          }
        });
    });
  };
};
export const deleteSubCategories = (
  superCategoryId,
  categoryId,
  subCategoryId
) => {
  return (dispatch) => {
    return new Promise(async (resolve, reject) => {
      await axios
        .delete(
          `/admin/sub-category/delete?superCategoryId=${superCategoryId}&categoryId=${categoryId}&subCategoryId=${subCategoryId}`
        )
        .then(() => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Sub-Category deleted' }
          });
          resolve(true);
        })
        .catch((error) => {
          dispatch({
            type: 'ERROR_MESSAGE',
            payload: { error: 'Unable to delete this Sub-Category' }
          });
          reject(false);
        });
    });
  };
};

export const getSubCategoryDetails = (categoryId, subCategoryId) => {
  return (dispatch) => {
    axios
      .get(
        `/admin/sub-category/details/categoryId/${categoryId}/subCategoryId/${subCategoryId}`
      )
      .then((data) => {
        dispatch({ type: 'GET_SUB_CATEGORY_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'Loading..' });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllVendors = (i = 1, per_page_limit = 10) => {
  return (dispatch) => {
    axios
      .get(`/admin/vendor/listing?page_number=${i}&per_page_limit=${per_page_limit}`)
      .then((data) => {
        dispatch(getTotalPage(1, 'admin/vendor/listing', per_page_limit));
        dispatch({ type: 'GET_ALL_VENDORS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllEventsByIp = (ip) => {
  return (dispatch) => {
    axios
      .get(`/admin/eventsByIpList?ip=${ip}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_EVENTS_BY_IP', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllEvents = (i = 1, per_page_limit = 10) => {
  return (dispatch) => {
    axios
      .get(`/admin/eventsList?page_number=${i}&per_page_limit=${per_page_limit}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_EVENTS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getAllDiscounts = (i = 1, per_page_limit = 10) => {
  return (dispatch) => {
    axios
      .get(`/admin/discountsList?page_number=${i}&per_page_limit=${per_page_limit}`)
      .then((data) => {
        dispatch({ type: 'GET_ALL_DISCOUNTS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getTotalPage = (i, link, per_page_limit = 10) => {
  return (dispatch) => {
    axios
      .get(`/${link}?page_number=${i}&per_page_limit=${per_page_limit}`)
      .then((data) => {
        if (data.data.data.length !== 0) {
          i++;
          dispatch(getTotalPage(i, link, per_page_limit));
        } else {
          dispatch({ type: 'PAGE_COUNT', payload: i });
        }
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const addZipcode = (zipcode) => {
  return async (dispatch) => {
    axios
      .post('/add/zipcode', zipcode)
      .then((data) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
        // dispatch(getZipcode());
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getZipcode = () => {
  return (dispatch) => {
    axios
      .get('/get/all/zipcode')
      .then((data) => {
        dispatch({ type: 'GET_ZIPCODE', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const addPromocode = (promocode) => {
  return (dispatch) => {
    axios
      .post('/add/promocode', promocode)
      .then((data) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getPromocode = () => {
  return (dispatch) => {
    axios
      .get('/get/all/promocode')
      .then((data) => {
        dispatch({ type: 'GET_PROMOCODE', payload: data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const addRestaurantCategory = (category) => {
  return async (dispatch) => {
    axios
      .post('/add/category/restaurant', { category: category })
      .then((data) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getRestaurantCategory = () => {
  return (dispatch) => {
    axios
      .get('/get/category/restaurant')
      .then((data) => {
        dispatch({ type: 'GET_RESTAURANT_CATEGORY', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const addVendor = (vendor) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/vendor/save', vendor)
        .then((data) => {
          dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Vendor successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          } catch {
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          } finally {
            reject(false);
          }
        });
    });
  };
};
export const getAllVendor = () => {
  return (dispatch) => {
    axios
      .get('/admin/vendor/listing?page_number=1&per_page_limit=10')
      .then((data) => {
        dispatch({ type: 'GET_VENDOR', payload: data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};
export const updateVendor = (vendor) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/vendor/update', vendor)
        .then((data) => {
          dispatch({ type: 'UPDATE_VENDOR', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Vendor successfully updated' }
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({
              type: 'UPDATE_VENDOR_ERROR',
              payload: error.response.data
            });
          } catch {
            dispatch({
              type: 'UPDATE_VENDOR_ERROR',
              payload: 'please try again'
            });
          } finally {
            reject(false);
          }
        });
    });
  };
};
export const deleteDiscount = (id) => {
  return async (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/admin/discount/delete/${encodeURI(id)}`).then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Discount deleted' }
          });
          resolve(true);
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Vendor' }
        });
        reject(false);
      }
    });
  };
};
export const addWalletAmount = (id, amount) => {
  return async (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await axios
          .put('/admin/user/addWalletAmount', { id, amount })
          .then((data) => {
            dispatch({
              type: 'SUCCESS_MESSAGE',
              payload: { general: 'Wallet Updated' }
            });
            resolve(true);
          });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Vendor' }
        });
        reject(false);
      }
    });
  };
};
export const deleteDriver = (id) => {
  return async (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/admin/driver/delete/${encodeURI(id)}`).then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Driver deleted' }
          });
          resolve(true);
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Vendor' }
        });
        reject(false);
      }
    });
  };
};
export const deleteVendor = (vendorId) => {
  return async (dispatch) => {
    return new Promise(async (resolve, reject) => {
      try {
        await axios.delete(`/admin/vendor/delete/${vendorId}`).then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Vendor deleted' }
          });
          resolve(true);
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'Unable to delete Vendor' }
        });
        reject(false);
      }
    });
  };
};

export const getVendorDetails = (vendorId) => {
  return (dispatch) => {
    axios
      .get(`/admin/vendor/details/${vendorId}`)
      .then((data) => {
        dispatch({ type: 'GET_VENDOR_DETAILS', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const approveVendor = (vendor) => {
  return (dispatch) => {
    axios
      .post('/store/vendor/credentials', { ...vendor })
      .then((doc) => {
        axios
          .post('/approve/vendor', { ...vendor, uid: doc.data.userId })
          .then((doc) => {
            dispatch({ type: 'SUCCESS_MESSAGE', payload: doc.data });
          })
          .catch((error) => {
            dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          });
        dispatch({ type: 'SUCCESS_MESSAGE', payload: doc.data });
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const addProduct = (product) => {
  return (dispatch) => {
    axios
      .post('/add/product', product)
      .then((data) => {
        dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const getVendorOrders = (id) => {
  return (dispatch) => {
    axios
      .post('/', {
        Id: id
      })
      .then((data) => {
        //   dispatch({type:GET_INDIVIDUAL_PRODUCT,payload:data})
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const deleteVendors = (vendor) => {
  return async (dispatch) => {
    if (vendor.isVerified === 'approved') {
      try {
        await axios.post('/delete/vendor/from/category', vendor);
        await axios.delete(`/delete/vendor/products/${vendor.authId}`);
        await axios.delete(`/delete/vendor/information/${vendor.docId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'user deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete user' }
        });
      }
    } else {
      try {
        await axios.delete(`/delete/vendor/information/${vendor.docId}`);
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: { general: 'user deleted' }
        });
      } catch (error) {
        dispatch({
          type: 'ERROR_MESSAGE',
          payload: { error: 'unable to delete user' }
        });
      }
    }
  };
};

export const deleteZipcode = (name) => {
  return (dispatch) => {
    axios
      .delete(`/delete/zipcode/${name}`)
      .then(() => {
        dispatch(getZipcode());
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const deletePromocode = (name) => {
  return (dispatch) => {
    axios
      .delete(`/delete/promocode/${name}`)
      .then(() => {
        dispatch(getPromocode());
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const deleteProduct = (product) => {
  return (dispatch) => {
    axios
      .post(`/delete/product`, product)
      .then(() => {
        dispatch(getAllProducts('', '', '', '', product.Id));
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const deleteRestaurantCategories = (category) => {
  return (dispatch) => {
    axios
      .post(`/delete/restaurant/categories`, category)
      .then(() => {
        dispatch(getRestaurantCategory());
      })
      .catch((error) => {
        dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
      });
  };
};

export const addNewDistance = (distance) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/distance/save', distance)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Distance Created Successfully' }
          });
          resolve(true);
        })
        .catch((error) => {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          reject(false);
        });
    });
  };
};

export const getAllDistance = () => {
  return (dispatch) => {
    axios
      .get('/admin/distance/listing')
      .then((data) => {
        dispatch({ type: 'GET_ALL_DISTANCE', payload: data.data });
      })
      .catch((error) => {
        try {
          dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
        } catch {
          dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
        }
      });
  };
};

export const updateDistance = (distance) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/distance/update', distance)
        .then((data) => {
          dispatch({ type: 'UPDATE_DISTANCE_SUCCESS', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Distance Updated Successfully' }
          });
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const createPinCode = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/admin/deliverypin/save', data)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Pincode Created Successfully' }
          });
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const getAllPinCode = (pageNo) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/deliverypin/listing?page_number=${pageNo}&per_page_limit=10`)
        .then((data) => {
          dispatch({
            type: 'GET_PIN_CODE',
            payload: data.data
          });
        })
        .catch((err) => { });
    });
  };
};
export const updatePincodeDetails = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put('/admin/deliverypin/update', data)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Pincode Updated Successfully' }
          });
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const deletePincode = (id) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/admin/deliverypin/delete/${id}`)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Pincode Deleted Successfully' }
          });
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const unPublishPincode = (publishUnpublishData) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .put(`/admin/deliverypin/update/status`, publishUnpublishData)
        .then((data) => {
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: {
              general: `Pincode ${publishUnpublishData.status ? 'Published' : 'UnPublished'
                } Successfully`
            }
          });
          resolve(true);
        })
        .catch((err) => {
          reject(false);
        });
    });
  };
};

export const getOrderListForDownload = (status, orderRef = '', orderType = '', startTime = '', endTime = '',dropPhone='', placedBy='') => {
  return (dispatch) => {
    dispatch({ type: 'ADMIN_API_PROGRESS', payload: true });
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/orderhistory/${status}?orderRef=${orderRef}&orderType=${orderType}&startTime=${startTime}&endTime=${endTime}&dropPhone=${dropPhone}&placedBy=${placedBy}`)
        .then((resp) => {
          dispatch({ type: 'ADMIN_API_PROGRESS', payload: false });
          resolve(resp.data);
        })
        .catch((err) => {
          dispatch({ type: 'ADMIN_API_PROGRESS', payload: false });
          reject(false);
        });
    });
  };
};

export const getOrderList = (status, pageNumber = 1, orderRef = '', orderType = '', startTime = '', endTime = '',dropPhone='', placedBy='') => {
  return (dispatch) => {
    dispatch({ type: 'ADMIN_API_PROGRESS', payload: true });
    return new Promise((resolve, reject) => {
      axios
        .get(`/admin/orderhistory/${status}?page_number=${pageNumber}&per_page_limit=10&orderRef=${orderRef}&orderType=${orderType}&startTime=${startTime}&endTime=${endTime}&dropPhone=${dropPhone}&placedBy=${placedBy}`)
        .then((resp) => {
          dispatch({ type: 'ADMIN_API_PROGRESS', payload: false });
          dispatch({
            type: 'GET_ORDER_LIST',
            payload: resp.data
          });
          resolve(true);
        })
        .catch((err) => {
          dispatch({ type: 'ADMIN_API_PROGRESS', payload: false });
          reject(false);
        });
    });
  };
};

export const updateOrderStatus = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put('/admin/update-order-status', data).then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: {
            general: 'Order Status updated successfully'
          }
        });
        resolve(true);
      });
    });
  };
};


export const updateOrderDriver = (data) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios.put('/admin/update-order-driver', data).then((data) => {
        dispatch({
          type: 'SUCCESS_MESSAGE',
          payload: {
            general: 'Order Delivery Boy updated successfully'
          }
        });
        resolve(true);
      });
    });
  };
};


export const updateCommission = (payload) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .post('/flights/updateCommission', payload)
        .then((data) => {
          dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
          dispatch({
            type: 'SUCCESS_MESSAGE',
            payload: { general: 'Commision successfully updated' }
          });
          dispatch({
            type: 'UPDATE_ADMIN_COMMISSION',
            data: payload
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          } catch {
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          } finally {
            reject(false);
          }
        });
    });
  };
};

export const getCommission = () => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get('/flights/commission' )
        .then((data) => {
          dispatch({ type: 'SUCCESS_MESSAGE', payload: data.data });
          if(data.data)
          dispatch({
            type: 'UPDATE_ADMIN_COMMISSION',
            data: data.data.data
          });
          resolve(true);
        })
        .catch((error) => {
          try {
            dispatch({ type: 'ERROR_MESSAGE', payload: error.response.data });
          } catch {
            dispatch({ type: 'ERROR_MESSAGE', payload: 'please try again' });
          } finally {
            reject(false);
          }
        });
    });
  };
};